import { Button } from '@/components/Button';
import { FanOutPics } from '@/components/FanOutPics';
import { Slide1Template } from '@/templates/Slide1Template';
import { Slide2Template } from '@/templates/Slide2Template';
import { Slide3Template } from '@/templates/Slide3Template';

interface WelcomeStepProps {
    onNext: () => void;
}

export const WelcomeStep = ({ onNext }: WelcomeStepProps) => {
    return (
        <>
            <div className='flex-1 flex flex-col justify-center items-center gap-4 w-full overflow-y-auto overflow-x-hidden  px-4'>
                <FanOutPics image1={<Slide1Template />} image2={<Slide2Template />} image3={<Slide3Template />} />
            </div>
            <div className="shrink-0 flex justify-center items-center w-full px-8">
                <Button label="Start" onClick={onNext} />
            </div>
        </>
    );
};
